// frontend/src/main.jsx
// SignalIQ — Main Entry

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./styles/theme.css";
import "./styles/globals.css";
import "./styles/shared.css";
import "./styles/ingestion.css";

document.documentElement.setAttribute("data-theme", "dark");
document.documentElement.style.background = "#080f1c";
document.documentElement.style.color = "#e8f0fe";

window.CESIUM_BASE_URL = "/cesium";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);